"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwimlaneItemType = exports.LayoutType = void 0;
var LayoutType;
(function (LayoutType) {
    LayoutType["Global"] = "Global";
    LayoutType["Activity"] = "Activity";
    LayoutType["ApplicationDefault"] = "ApplicationDefault";
    LayoutType["Swimlane"] = "Swimlane";
    LayoutType["Workspaces"] = "Workspace";
})(LayoutType || (exports.LayoutType = LayoutType = {}));
var SwimlaneItemType;
(function (SwimlaneItemType) {
    SwimlaneItemType["Tab"] = "tab";
    SwimlaneItemType["Window"] = "window";
    SwimlaneItemType["Canvas"] = "canvas";
})(SwimlaneItemType || (exports.SwimlaneItemType = SwimlaneItemType = {}));
//# sourceMappingURL=layout.js.map